import { render } from "./ColumnList.vue?vue&type=template&id=6cddad8e&scoped=true"
import script from "./ColumnList.vue?vue&type=script&lang=js"
export * from "./ColumnList.vue?vue&type=script&lang=js"

import "./ColumnList.vue?vue&type=style&index=0&id=6cddad8e&lang=scss&scoped=true"

import exportComponent from "F:\\my-work\\company\\yuanxi\\yuanxi-csspw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cddad8e"]])

export default __exports__